import React from 'react';
// import { Redirect } from 'react-router-dom';
import './insights.scss';
import Header from '../../containers/Header/header';
import Footer from '../../containers/Footer/footer';
import { auth as AuthObject } from '../../services/login'
import '../../containers/Header/header.scss';
import cookie from '../../cookieHelper/cookie';
import toastNotify from '../../utils/toastNotifier';
import getReelInsights from '../../services/getReelInsights';
import getReelInsightsV2 from '../../services/getReelInsightsV2';
import withRouter from '../../containers/withRouter';
import { Navigate } from 'react-router-dom';


class ReelsInsights extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPlatform: " ",
            totalData: "",
            startDate: "",
            endDate: "",
            totalReportData: "",
            clicked: false,
            tokencheck: true
        }

        this.storyId = this.props.params.storyID;
        this.data = {
            storyId: this.storyId
        }
        this.validateData(this.data);
    }
    setCompanyID = (e) => {
        e.preventDefault();
        this.setState({
            selectedPlatform: e.target.value
        })
    }

    setStartDate = (e) => {
        e.preventDefault();
        this.setState({
            startDate: e.target.value
        })
    }
    setEndDate = (e) => {
        e.preventDefault();
        this.setState({
            endDate: e.target.value
        })
    }

    handleClick = async (e) => {
        e.preventDefault();
        this.setState({
            clicked: true
        })
        const data = {
            startDate: this.state.startDate,
            endDate: this.state.endDate
        }
        if (this.state.startDate != "" && this.state.endDate != ""){
            let result = await getReelInsightsV2(data, "reel");
            if (!(result instanceof Error)) {
                if (result.status.code == "10200") {
                    result = result.data;
                    this.setState({
                        totalReportData: result
                    })
                }
                else {
                    this.setState({
                        totalReportData: 'error'
                    })
                    toastNotify(3, "Something went wrong");
                }
            }
            else {
                this.setState({
                    totalReportData: 'error'
                })

                const response = JSON.parse(result.request.response);
                const code = response?.status?.code;


                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                toastNotify(3, "Some error occured");
            }
        }
        else{
            toastNotify(3, "please select start-end dates");
        }        
    }
    
    onSubmit = async (e) => {
        e.preventDefault();

        const data = {
            platform: this.state.selectedPlatform,
        }

        this.validateData(data, e)
    }
    validateData = async (data, e) => {
        let result = await getReelInsights(data.storyId, "reel");
        if (!(result instanceof Error)) {
            if (result.status.code == "10200") {
                result = result.data[0];
                this.setState({
                    totalData: result
                })
            }
            else {
                this.setState({
                    totalData: 'error'
                })
                toastNotify(3, "Something went wrong");
            }
        }
        else {
            this.setState({
                totalData: 'error'
            })

            const response = JSON.parse(result.request.response);
                const code = response?.status?.code;


                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
            
            toastNotify(3, "Some error occured");
        }
    }
    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        let analysisCardContent;
        if (typeof this.storyId == 'undefined') {

            analysisCardContent = (
                <div>
                    <p className="spacing-metric"><b>Total Views :</b> {this.state.totalData.totalViewCount}</p>
                    <p className="spacing-metric"><b>Total Claps :</b> {this.state.totalData.totalClapCount}</p>
                    <p className="spacing-metric"><b>Unique Views :</b> {this.state.totalData.uniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique Claps :</b> {this.state.totalData.uniqueClapCount}</p>

                    <p className="spacing-metric"><b>Total iimjobs Views :</b> {this.state.totalData.iimjobsTotalViewCount}</p>
                    <p className="spacing-metric"><b>Total iimjobs Claps :</b> {this.state.totalData.iimjobsTotalClapCount}</p>

                    <p className="spacing-metric"><b>Total hirist Views :</b> {this.state.totalData.hiristTotalViewCount}</p>
                    <p className="spacing-metric"><b>Total hirist Claps :</b> {this.state.totalData.hiristTotalClapCount}</p>


                    <p className="spacing-metric"><b>Unique iimjobs Views :</b> {this.state.totalData.iimjobsUniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique iimjobs Claps :</b> {this.state.totalData.iimjobsUniqueClapCount}</p>
                    <p className="spacing-metric"><b>Unique hirist Views :</b> {this.state.totalData.hiristUniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique hirist Claps :</b> {this.state.totalData.hiristUniqueClapCount}</p>
                </div>
            )
        }
        else {
            analysisCardContent = (
                <div>
                    <p className="spacing-metric"><b>Total Views :</b> {this.state.totalData.totalViewCount}</p>
                    <p className="spacing-metric"><b>TotalClaps :</b> {this.state.totalData.totalClapCount}</p>
                    <p className="spacing-metric"><b>Unique Views :</b> {this.state.totalData.uniqueViewCount}</p>
                    <p className="spacing-metric"><b>Unique Claps :</b> {this.state.totalData.uniqueClapCount}</p>
                </div>
            )
        }
        let analysisCardReportContent;
        analysisCardReportContent = (
           <div className="report-card-content">
                <p className="heading-report"><b>Reel Report</b></p>
                <table border="1" className="story-report">
                    <tbody>
                        <tr className="table_header">
                            <th className="table_header">Sn no.</th>
                            <th className="table_header">Portal</th>
                            <th className="table_header">Total Reels this month</th>
                            <th className="table_header">Total Brands this month</th>
                            <th className="table_header">Views</th>
                            <th className="table_header">Claps</th>
                        </tr>
                        <tr className="table_content">
                            <td className="table_content"><p>1</p></td>
                            <td className="table_content"><p>iimjobs</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsReels}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsBrands}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsViews}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.iimjobsClaps}</p></td>
                        </tr>
                        <tr className="table_content">
                            <td className="table_content"><p>2</p></td>
                            <td className="table_content"><p>hirist</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristReels}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristBrands}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristViews}</p></td>
                            <td className="table_content"><p>{this.state.totalReportData.hiristClaps}</p></td>
                        </tr>
                        <tr className="table_content">
                            <td className="table_content"><p></p></td>
                            <td className="table_content"><p><b>Total</b></p></td>
                            <td className="table_content"><p><b>{this.state.totalReportData.iimjobsReels+this.state.totalReportData.hiristReels}</b></p></td>
                            <td className="table_content"><p><b>{this.state.totalReportData.iimjobsBrands+this.state.totalReportData.hiristBrands}</b></p></td>
                            <td className="table_content"><p><b>{this.state.totalReportData.iimjobsViews+this.state.totalReportData.hiristViews}</b></p></td>
                            <td className="table_content"><p><b>{this.state.totalReportData.iimjobsClaps+this.state.totalReportData.hiristClaps}</b></p></td>
                        </tr>    
                    </tbody>
                </table>
           </div>    
        )

        let activeUniqueBrandsRows;
        if (this.state.totalReportData.uniqueBrands && this.state.totalReportData.uniqueBrands.length){
            activeUniqueBrandsRows = (
                this.state.totalReportData.uniqueBrands.map((item, index) => {
                    return (
                        <tr key={index} rowindex={index} className="table_content"  >
                            <td>
                                <p>{index}</p>
                            </td>
                            <td>
                                <p>{item.name}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsReels && item.hiristReels ? item.iimjobsReels+item.hiristReels : item.iimjobsReels ? item.iimjobsReels : item.hiristReels ? item.hiristReels : 0}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsReels ? item.iimjobsReels : 0}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsTotalViewCount ? item.iimjobsTotalViewCount : 0}</p>
                            </td>
                            <td>
                                <p>{item.iimjobsTotalClapCount ? item.iimjobsTotalClapCount : 0}</p>
                            </td>
                            <td>
                                <p>{item.hiristReels ? item.hiristReels : 0}</p>
                            </td>
                            <td>
                                <p>{item.hiristTotalViewCount ? item.hiristTotalViewCount : 0}</p>
                            </td>
                            <td>
                                <p>{item.hiristTotalClapCount ? item.hiristTotalClapCount : 0}</p>
                            </td>
                        </tr>
                    )
                })
            )
        }
        let analysisCardUniqueBrandsContent;
        analysisCardUniqueBrandsContent = (
            <div>
                <table border="1" className="story-uniqueBrands-report">
                    <tbody>
                        <tr className="table-header">
                            <th className="table_header">Sn no.</th>
                            <th className="table_header">Unique Brands</th>
                            <th className="table_header">No. Of Reels</th>
                            <th className="table_header">iimjobs</th>
                            <th className="table_header">hirist</th>
                        </tr>
                        {activeUniqueBrandsRows}   
                    </tbody>
                </table>
            </div>
        )
        return (
            <div className="bodyWrapper">
                <Header />
                <section className="insights_header">
                    <h1>Reel Insights</h1>
                    <div className="main-wrapper">

                        <div className="insights-wrapper">
                            <h3 className={"loader " + (this.state.totalData == "" ? '' : 'hidden')}><b>Loading...</b></h3>
                            <div className="wrapper">
                                <div className={"wrapperForm " + (this.state.totalData == "" || this.state.totalData == 'error' ? 'hidden' : '')}>
                                   
                                    <div className="analysis-card" >
                                        {analysisCardContent}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="insights-report">
                            <div className="date-box">
                                <div className="startDateContainer"> 
                                    <div className="date-label form-group-heading">Start Date*</div>
                                    <input className="date-input" type="date" onChange={this.setStartDate} />
                                </div>
                                <div className="endDateContainer">
                                    <div className="date-label form-group-heading">End Date*</div>
                                    <input className="date-input" type="date" onChange={this.setEndDate} />
                                </div>
                            </div>
                            <div className="submitButton">
                                <button className="buttonReport submit-report-btn" onClick={this.handleClick}>Submit</button>
                            </div>

                            <h3 className={"loader " + (this.state.clicked == true && this.state.totalReportData == '' ? '' : 'hidden')}><b>Loading...</b></h3>
                            <div className="wrapper">
                                <div className={"wrapperForm " + (this.state.totalReportData == "" || this.state.totalReportData == 'error' ? 'hidden' : '')}>
                                    <div className="analysisReport-card" >
                                        {analysisCardReportContent}
                                    </div>
                                </div>
                                <div className={"wrapperForm " + (this.state.totalReportData == "" || this.state.totalReportData == 'error' ? 'hidden' : '')}>
                                    <div className="analysisReport-card unique-brands-report" >
                                        <div>
                                            <table border="1" className="story-uniqueBrands-report">
                                                <tbody>
                                                    <tr className="table-header">
                                                        <th className="table_header">Sn no.</th>
                                                        <th className="table_header">Unique Brands</th>
                                                        <th className="table_header">No. Of Stories</th>
                                                        <th className="table_header">iimjobs</th>
                                                        <th className="table_header">iimjobsTotalViewCount</th>
                                                        <th className="table_header">iimjobsTotalClapCount</th>
                                                        <th className="table_header">hirist</th>
                                                        <th className="table_header">hiristTotalViewCount</th>
                                                        <th className="table_header">hiristTotalClapCount</th>

                                                    </tr>
                                                    {activeUniqueBrandsRows}   
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        )
    }
}
export default withRouter(ReelsInsights);